<template lang="html">
  <div class="mpv-checkbox radio form-check custom-radio py-1">
    <input
      @change="$emit('change', name, value)"
      type="radio"
      class="form-check-input"
      :disabled="disabled"
      :checked="checked"
      :name="name"
      :value="value">
    <span class="checkmark"><span></span></span>
    <label class="radio-tooltip-label form-check-label" for="">
      {{ label }}
      <span class="www" style="position: relative;">
        <i
          v-if="tooltip"
          class="radio-tooltip-icon fa fa-question-circle">
        </i>
        <span class="tooltip-text">{{ tooltip }}</span>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    value: String,
    label: String,
    tooltip: String,
    checked: Boolean,
    disabled: Boolean
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .radio-tooltip {
    position: relative;

    &-label {
      padding-left: 1rem;
    }

    &-icon {
      color: $secondary !important;
      font-size: 1rem !important;
      padding-left: 0.5rem;

      & ~ .tooltip-text {
        opacity: 0;
        background-color: $dark;
        color: $white;
        text-align: center;
        border-radius: 0px;
        box-shadow: 1px 2px $gray-200;
        padding: 0 1rem;
        position: absolute;
        bottom: 140%;
        z-index: 1;
        transition: ease 0.3s;
        max-width: 40vw;
        width: max-content;
        padding: 0.5rem;
        // left: -40px;
        left: -100px;
        // top: 10px;
        display: none;

        &:before {
          position: absolute;
          /* top: 21px; */
          // left: 47px;
          left: 108px;
          content: "";
          border-left: 8px solid transparent;
          border-right: -3px solid transparent;
          bottom: -8px;
          border-top: 9px solid $dark;
        }
      }

      &:hover ~ .tooltip-text {
        opacity: 1;
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/RadioTooltip.vue